<template>
  <PageHeaderLayout :isBack="true">
    <div class="main-page-content">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        class="training-form"
      >
        <el-form-item label="培训名称" prop="name" required>
          <el-input
            v-model="form.name"
            placeholder="请输入培训名称"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="培训封面" prop="cover">
          <UploadImg
            ref="uploadImgRef"
            :accept="['png', 'jpg', 'jpeg']"
            :upload-props="{ maxSize: 2 }"
            @handleSuccess="onCoverSuccess"
          />
          <div class="upload-tip">格式支持JPEG、PNG</div>
        </el-form-item>
        <el-form-item label="状态" prop="status" required>
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="开启"
            inactive-text="关闭"
          ></el-switch>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <ApeEditor
            :init-html="form.content"
            :editor-height="300"
            :oss-data="ossData"
            :oss-obj="ossObj"
            @handleTinymceInput="handleTinymceInput"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import UploadImg from "@/components/uploadImg/index.vue";
import ApeEditor from "@/components/ApeEditor/ApeEditor.vue";

export default {
  components: {
    PageHeaderLayout,
    UploadImg,
    ApeEditor,
  },
  data() {
    return {
      ossData: {},
      ossObj: {},
      form: {
        name: "",
        cover: "", // 封面上传后的 URL
        cover_url: "", // 封面展示地址（编辑时）
        status: 1,
        content: "",
      },
      rules: {
        name: [{ required: true, message: "请输入培训名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    isEdit() {
      return !!this.id && this.id !== "create";
    },
  },
  watch: {
    $route: {
      handler() {
        if (this.isEdit) {
          this.loadDetail();
        } else {
          this.resetForm();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getOssSign();
  },
  methods: {
    async getOssSign() {
      try {
        const ossDir = `${this.$config.ossAppDir || ""}/bill`;
        const res = await this.$api.getOssSign({ dir: ossDir });
        if (res) {
          this.ossObj = { ...res, dir: res.dir || ossDir };
          this.ossData = {
            ossAccessKeyId: res.accessid,
            policy: res.policy,
            signature: res.signature,
          };
        }
      } catch (e) {
        console.error("获取OSS签名失败", e);
      }
    },
    handleTinymceInput(val) {
      this.form.content = val;
    },
    onCoverSuccess() {
      this.form.cover = this.$refs.uploadImgRef
        ? this.$refs.uploadImgRef.getImagesList()
        : [];
      this.form.cover_url = this.form.cover.join(",") || "";
      this.$refs.form && this.$refs.form.validateField("cover");
    },
    async loadDetail() {
      try {
        const res = await this.$api.getTrainingInfo(this.id);
        const info = res.info || res.data || res;
        const coverList = typeof info.cover_url === "string"
          ? info.cover_url.split(",").map((url) => url.trim()).filter(Boolean)
          : [];

        this.form = {
          name: info.name || "",
          cover: coverList,
          cover_url: info.cover_url || "",
          status: info.status !== undefined ? Number(info.status) : 1,
          content: info.content || "",
        };
        this.$nextTick(() => {
          if (this.$refs.uploadImgRef && this.form.cover.length) {
            this.$refs.uploadImgRef.setImagesList(this.form.cover);
          }
        });
      } catch (e) {
        this.$message.error(e.message || "获取详情失败");
      }
    },
    resetForm() {
      this.form = {
        name: "",
        cover: "",
        cover_url: "",
        status: 1,
        content: "",
      };
      this.$refs.form && this.$refs.form.resetFields();
      this.$nextTick(() => {
        if (this.$refs.uploadImgRef && this.$refs.uploadImgRef.setImagesList) {
          this.$refs.uploadImgRef.setImagesList([]);
        }
      });
    },
    goBack() {
      this.$router.push({ path: "/training" });
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.form.cover = this.$refs.uploadImgRef
          ? this.$refs.uploadImgRef.getImagesList()
          : [];
        this.form.cover_url = this.form.cover.join(",") || "";
        if (!this.form.cover.length) {
          this.$message.warning("请上传培训封面");
          return;
        }
        const payload = {
          name: this.form.name,
          status: this.form.status,
          content: this.form.content,
          cover_url: this.form.cover_url,
        };
        if (this.isEdit) {
          payload.id = this.id;
        }
        try {
          await this.$api.saveTraining(payload);
          this.$message.success("保存成功");
          this.$router.push({ path: "/training" });
        } catch (e) {
          this.$message.error(e.message || "保存失败");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}
</style>
